

const BASE_URL = "https://krumago-application-assets.s3.us-east-1.amazonaws.com/Payment+Assets/";
 export const PAYMENT = {

    IMAGES: {
        IMAGE_1: `${BASE_URL}logo.png`,
        IMAGE_2: `${BASE_URL}img1.jpeg`,

    },
};